import React, { Component } from 'react';
import add_blue_circle from './add_blue_circle.svg';
import Box from 'common/Box';
import Link from 'common/Link';
import InsurancePurchaseLink from './InsurancePurchaseLink';
import { generateLinksList } from './utils';

class InsuranceLink extends Component {

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    const { sprintSubId, bypassedSubId, quickSubId, user } = this.props;
    if (
        sprintSubId !== oldProps.sprintSubId ||
        bypassedSubId !== oldProps.bypassedSubId || 
        quickSubId !== oldProps.quickSubId || 
        user !== oldProps.user
      ) {
      user && this.fetchData();
    }
  } 

  fetchData = () => {
    const { 
      user,
      fetchData,
      sprintSubId: subscription,
      bypassedSubId: bypassed_subscription,
      quickSubId: quick_subscription,
     } = this.props;
    fetchData({
      subscription,
      bypassed_subscription,
      quick_subscription,
      userId: user && user.id,
    });
  }

  renderLinks = (links) => (
    links.map(({ to, text, type }) => (
      type === 'insurancePurchase'
        ? <InsurancePurchaseLink to={to} key={to} />
        : <Link className={this.props.className} to={to} key={to}>
            <Box>
              <img src={add_blue_circle} alt="add icon" />
              {text}
            </Box>
          </Link>
    ))
  )

  render() {
    const { contracts, sprintSubId, bypassedSubId, quickSubId, purchases, devices } = this.props;
    if (!contracts) { return null }

    return this.renderLinks(generateLinksList({ contracts, sprintSubId, bypassedSubId, quickSubId, purchases, devices }));
  }
}

export default InsuranceLink;
